import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext.js";
import { useNavigate } from "react-router-dom";

//const API = "http://127.0.0.1:8001";

const API = process.env.REACT_APP_API_URL;

function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: ""
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(`${API}/hr-login`, form);
      login(res.data.access_token);
      navigate("/cv");
    } catch (err) {
      setError("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
      <div>
        <header className="topbar" style={{ background: "linear-gradient(135deg, #004687, #003366)" }}>
          <span className="topbar-title"></span>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <button className="logout-btn" onClick={() => navigate("/")} style={{ background: "white", color: "black" }}>
              🏠 Portal Hub
            </button>
          </div>
        </header>
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>🔐 HR Login</h2>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            type="username"
            placeholder="Username"
            value={form.email}
            onChange={(e) =>
              setForm({ ...form, email: e.target.value })
            }
            style={styles.input}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={(e) =>
              setForm({ ...form, password: e.target.value })
            }
            style={styles.input}
            required
          />

          <button style={styles.button} disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #004687, #003366)"
  },
  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "20px",
    width: "350px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.3)"
  },
  title: {
    marginBottom: "25px",
    textAlign: "center",
    color: "#004687"
  },
  input: {
    width: "100%",
    padding: "14px",
    marginBottom: "15px",
    borderRadius: "10px",
    border: "2px solid #e2e8f0",
    fontSize: "14px"
  },
  button: {
    width: "100%",
    padding: "14px",
    borderRadius: "10px",
    border: "none",
    background: "linear-gradient(135deg, #004687, #003366)",
    color: "#fff",
    fontWeight: "600",
    cursor: "pointer"
  },
  error: {
    background: "#fee2e2",
    color: "#dc2626",
    padding: "10px",
    borderRadius: "8px",
    marginBottom: "15px",
    textAlign: "center"
  }
};

export default AdminLogin;
